var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 16.0012V14.3346C14.6663 13.4505 14.3152 12.6027 13.69 11.9775C13.0649 11.3524 12.2171 11.0012 11.333 11.0012H4.66634C3.78229 11.0012 2.93444 11.3524 2.30932 11.9775C1.6842 12.6027 1.33301 13.4505 1.33301 14.3346V16.0012M19.6663 16.0012V14.3346C19.6658 13.596 19.42 12.8785 18.9675 12.2948C18.515 11.7111 17.8814 11.2942 17.1663 11.1096M13.833 1.10955C14.55 1.29314 15.1855 1.71014 15.6394 2.29481C16.0932 2.87949 16.3395 3.59858 16.3395 4.33872C16.3395 5.07886 16.0932 5.79795 15.6394 6.38263C15.1855 6.9673 14.55 7.3843 13.833 7.56789M11.333 4.33455C11.333 6.1755 9.84062 7.66789 7.99967 7.66789C6.15872 7.66789 4.66634 6.1755 4.66634 4.33455C4.66634 2.4936 6.15872 1.00122 7.99967 1.00122C9.84062 1.00122 11.333 2.4936 11.333 4.33455Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientActive);
export default __webpack_public_path__ + "static/media/client-active.46f6d599a82062c5603efe7361127ee8.svg";
export { ForwardRef as ReactComponent };